export default __webpack_public_path__ + "static/media/template_pro__0009_18---FedorHolz.833e5e82.png";